export const ruleTranslations: { [key: string]: string } = {
  isAmount: "Should be a number with two decimals",
  isDate: "Should be a valid date",
  isIban: "Should be a valid IBAN number",
  notInFuture: "Should not be in the future",
  isVat: "Should be a valid VAT number",
};
